import { get } from 'lodash';
import { VALUE_SET_COMPUTABLE_NAMES } from '../constants';
import { useClient } from '../context/InteractionsContext';
import { useFind, usePopulate } from './APIHooks';
import { useValueSet } from './useValueSet';

export const useInteractions = ({ pageNumber, pageSize }) => {
  const client = useClient();
  const { conceptId: stateConceptId, isLoading: isStateLoading } = useValueSet(
    VALUE_SET_COMPUTABLE_NAMES.interactionState,
  );

  const { data, isLoading: isInteractionsLoading } = useFind(
    'interaction',
    { person: client.id, state_concept: stateConceptId },
    {
      page: { number: pageNumber, size: pageSize },
      queryConfig: {
        enabled: !!stateConceptId,
        placeholderData: undefined,
        refetchOnWindowFocus: false,
      },
    },
  );

  const interactions = get(data, 'data.data', []);

  const { isLoading: isRecordedByLoading } = usePopulate(
    'recorded_by',
    'employee',
    interactions,
    { queryConfig: { placeholderData: undefined } },
  );
  const { isLoading: isPerformingOrgLoading } = usePopulate(
    'performing_org',
    'provider',
    interactions,
    { queryConfig: { placeholderData: undefined } },
  );
  const { isLoading: isTypeConceptLoading } = usePopulate(
    'type_concept',
    'concept',
    interactions,
    { queryConfig: { placeholderData: undefined } },
  );

  const isLoading = isStateLoading ||
    !stateConceptId ||
    isInteractionsLoading ||
    isRecordedByLoading ||
    isPerformingOrgLoading ||
    isTypeConceptLoading;

  return { interactions, data, isLoading };
};
